import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { apiClient } from '@/lib/api';

interface Summary {
  pending_verification: number;
  pending_approval: number;
}

/**
 * PR MAY10 P5 — top-bar pending counter (🔧 with badge).
 * Polls /dashboard-summary every 60s. Click → maintenance list.
 */
export function MaintenanceCounter() {
  const [pending, setPending] = useState<number>(0);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const r = await apiClient.get<Summary>('/api/v1/maintenance/dashboard-summary');
        if (!cancelled) setPending(Number(r.data.pending_verification ?? 0) + Number(r.data.pending_approval ?? 0));
      } catch { /* user might not have permission — silently hide */ }
    }
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (pending === 0) return null;
  return (
    <Link to="/dashboard/maintenance/pending-verification"
      className="relative inline-flex items-center gap-1 rounded-md px-2 py-1.5 hover:bg-muted/40 transition-colors"
      title={`${pending} maintenance items pending`}>
      <Wrench className="h-4 w-4 text-stone-500" />
      <span className="absolute -top-1 -right-1 inline-flex items-center justify-center h-4 min-w-[1rem] px-1 rounded-full bg-rose-500 text-white text-[10px] font-medium">
        {pending}
      </span>
    </Link>
  );
}
